import { ConnectError } from '@bufbuild/connect';

import { NotFoundError } from '@/shared/config';
import { safeJSONParse } from '@/shared/lib';

// The backend answers the same way for a reset link that expired, was replaced
// by a newer one, or was already used.
export const isDeadResetLinkError = (error: unknown): boolean => {
  if (!(error instanceof ConnectError)) {
    return false;
  }

  const { type, entity } = safeJSONParse(error.rawMessage);

  return type === 'NotFoundError' && entity === NotFoundError.TOKEN;
};
